<template>
  <div class="sidebar__user">
    <UserSupport />
    <ImpersonateMenu />
    <v-menu bottom rounded offset-y>
      <template v-slot:activator="{ on }">
        <v-btn tile block v-on="on" elevation="0">
          <v-icon color="grey" size="26">
            mdi-account-circle-outline
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-list dense>
          <span v-for="(item, index) in menuItems">
            <v-list-item
              v-if="item.show"
              @click="item.action"
              :key="index"
              link
            >
              <v-icon color="grey lighten-1" left>
                {{ item.icon }}
              </v-icon>
              <span class="body-2">
                {{ item.label }}
              </span>
            </v-list-item>
          </span>
        </v-list>
      </v-card>
    </v-menu>
    <UpdateProfile ref="updateProfileModal" />
    <UpdatePassword :key="activeModal" />
    <UpdateRealEstateDetails v-if="isClient" />
    <UpdateLanguage />
  </div>
</template>

<script>
import { logout } from '@/services/auth/logout'
import { mapActions, mapGetters } from 'vuex'

import ImpersonateMenu from '@/components/impersonate/ImpersonateMenu.vue'
import UserSupport from './UserSupport.vue'
import UpdatePassword from './UpdatePassword'
import UpdateLanguage from './UpdateLanguage'
import UpdateProfile from '@/components/userOptions/UpdateProfile'
import UpdateRealEstateDetails from './UpdateRealEstateDetails'

export default {
  name: 'UserOptions',
  components: {
    ImpersonateMenu,
    UserSupport,
    UpdateProfile,
    UpdateLanguage,
    UpdatePassword,
    UpdateRealEstateDetails,
  },

  computed: {
    ...mapGetters(['activeModal']),

    isClient() {
      const accessRole = localStorage.getItem('access_roles')
      return accessRole?.includes('ROLE_REAL_ESTATE')
    },

    menuItems() {
      return [
        {
          label: this.$t('profile.label.updateRealEstate'),
          show: this.isClient,
          icon: 'mdi-store-edit-outline',
          action: () => this.openModal('UPDATE_REAL_ESTATE_DETAILS_MODAL')
        },
        {
          label: this.$t('profile.label.edit'),
          show: true,
          icon: 'mdi-account-edit-outline',
          action: () => this.openUpdateProfileModalAndFetchUser(),
        },
        {
          label: this.$t('profile.label.updatePassword'),
          show: true,
          icon: 'mdi-lock-reset',
          action: () => this.openModal('UPDATE_REAL_ESTATE_USER_PASSWORD_MODAL'),
        },
        {
          label: this.$t('profile.label.updateLanguage'),
          show: true,
          icon: 'mdi-web',
          action: () => this.openModal('UPDATE_COUNTRY_MODAL'),
        },
        {
          label: this.$t('profile.label.myPlan'),
          show: this.isClient,
          icon: 'mdi-credit-card-outline',
          action: () => this.goToMyPlan(),
        },
        {
          label: this.$t('auth.logout'),
          show: true,
          icon: 'mdi-exit-to-app',
          action: () => logout(),
        },
      ]
    }
  },

  methods: {
    ...mapActions(['openModal', 'fetchUser']),

    openUpdateProfileModalAndFetchUser() {
      this.fetchUser()
      this.openModal('UPDATE_PROFILE_MODAL')
    },

    goToMyPlan() {
      if (this.$route.name === 'myPlan') return
      this.$router.push({ name: 'myPlan' })
    },
  },
}
</script>
